import { createColumnHelper } from "@tanstack/react-table";
import styles from "./react-table-skeleton.module.scss";
import SkeletonC from "../../../stories/common/skeleton";
import { useMemo } from "react";

const useColumns = ({ yourOffersTab }: any) => {
  const columnHelper = createColumnHelper<any>();
  const recentPropertyColumns: any = useMemo(() => {
    return [
      columnHelper.accessor("posterImage", {
        id: "Image",
        header: "",
        cell: (props: any) => {
          return (
            <>
              {yourOffersTab ? (
                <div className={styles.imageSkeleton}>
                  <SkeletonC
                    width="90px"
                    height="65px"
                    className={styles.propertyImg}
                  />
                  <div className={styles.address}>
                    <SkeletonC
                      width="170px"
                      height="20px"
                      className={styles.skeletonAddressYourBids}
                    />
                    <div className={styles.text}>
                      <SkeletonC
                        width="170px"
                        height="20px"
                        className={styles.skeletonAddressYourBids}
                      />
                    </div>
                    <SkeletonC
                      width="170px"
                      height="20px"
                      className={styles.text}
                    />
                  </div>
                </div>
              ) : (
                <>
                  <div className={styles.imageSkeleton}>
                    <SkeletonC
                      width="90px"
                      height="65px"
                      className={styles.propertyImg}
                    />
                    <div className={styles.address}>
                      <SkeletonC
                        width="170px"
                        height="30px"
                        className={styles.skeletonAddress}
                      />
                      <div className={styles.text}>
                        <SkeletonC
                          width="170px"
                          height="30px"
                          className={styles.text}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          );
        }
      }),
      columnHelper.accessor("PRICE", {
        id: "PRICE",
        header: yourOffersTab ? "YOUR BID" : "PRICE",
        cell: (props: any) => (
          <>
            <SkeletonC
              width="150px"
              height="24px"
              className={styles.highestOffer}
            />
          </>
        )
      }),
      columnHelper.accessor("LOCATION", {
        id: "LOCATION",
        header: yourOffersTab ? "	BIDS SUBMITTED" : "LOCATION",
        cell: (props: any) => (
          <>
            <SkeletonC
              width="150px"
              height="24px"
              className={styles.highestOffer}
            />
          </>
        )
      }),
      columnHelper.accessor("status", {
        id: "status",
        header: yourOffersTab ? "DUE DATE" : "STATUS",
        cell: (props: any) => (
          <>
            {yourOffersTab ? (
              <>
                <SkeletonC
                  width="100px"
                  height="25px"
                  className={styles.statusSkeleton}
                />
                <SkeletonC
                  width="120px"
                  height="15px"
                  className={styles.status}
                />
              </>
            ) : (
              <SkeletonC
                width="100px"
                height="30px"
                className={styles.status}
              />
            )}
          </>
        )
      }),
      columnHelper.accessor("agentName", {
        id: "agent",
        header: yourOffersTab ? "STATUS" : "AGENT",
        cell: (props: any) => {
          return (
            <div className={styles.agent}>
              <SkeletonC shape="circle" size="2.2rem" />
              <SkeletonC width="120px" height="30px" className={styles.name} />
            </div>
          );
        }
      }),
      columnHelper.accessor("favCount", {
        id: "like",
        header: "",
        cell: (props: any) => {
          return (
            <>
              <SkeletonC shape="circle" size="2rem" />
            </>
          );
        }
      })
    ];
  }, []);
  return { recentPropertyColumns };
};

export default useColumns;
